import React from 'react';
import { Icon } from 'semantic-ui-react';
import GreenPlusButton from 'components/Buttons/GreenPlusButton';

const styles = {
	container: {
		width: '100%',
		height: 40,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: 15,
		marginTop: -10,
	},
	label: {
		float: 'left',
		fontSize: '1em',
	},
};

const AddCarbonCopie = ({
	customlabel = 'Carbon Copie',
	containerStyle,
	labelStyle,
	onClick,
	disabled,
	type,
}) => {
	return (
		<div style={{ ...styles.container, ...containerStyle }}>
			<span style={{ ...styles.label, ...labelStyle }}>{customlabel}</span>
			<GreenPlusButton
				text={<Icon name='add' style={{ margin: 0 }} />}
				onClick={onClick}
				disabled={disabled}
				type={type}
			/>
		</div>
	);
};

export default AddCarbonCopie;
